'use client';

import type {ReactNode} from 'react';
import {I18nProvider, type CompactTranslations} from '@udemy-v2/i18n';

import {COMMUNITIES_LOCALES, type CommunitiesLang} from './constants';

// `I18nProvider` calls `React.createContext` but its own module has no "use client"
// directive — it only works inside an existing client boundary. This wrapper provides
// that boundary so the (server) communities layout can render it.
export function CommunitiesI18nProvider({
    lang,
    translations,
    children,
}: {
    lang: CommunitiesLang;
    translations: CompactTranslations;
    children: ReactNode;
}) {
    return (
        <I18nProvider lang={lang} locale={COMMUNITIES_LOCALES[lang]} translations={translations}>
            {children}
        </I18nProvider>
    );
}
